import logger from '@/lib/logger'
import Modal from '@/components/shared/Modal'
import Anchor from '@/components/shared/Anchor'
import composesStyles from '@/styles/_settings/composes.module.css'
import styles from '@/styles/organisms/Modal/styles.module.css'

const CPTermsModal = ({show, loggerAction, onClose}) => {
  function onAnchorClick(type) {
    logger.action(loggerAction.profilemodallink, {type})
  }

  return (
    <Modal show={show} onClose={onClose}>
      <div className={styles.ecModal__header}>
        <p className={styles.ecModal__header__title}>
          TERMOS DE USO CORRETOR CAPTADOR
        </p>
      </div>
      <div className={styles.ecModal__content}>
        <div className={composesStyles.paddingx}>
          <p>
            Por meio dos termos e condições elencados no presente regulamento,
            EC NEGÓCIOS IMOBILIÁRIOS LTDA (“EmCasa”), inscrita no CNPJ sob o
            número 29.212.794/0001-39, resolve promover e coordenar o Programa
            de Corretores Captadores (“Programa”), com o objetivo de
            regulamentar a indicação de imóveis e pagamento de comissões. Todas
            as diretrizes e condições específicas estarão previstas no presente
            Regulamento, ficando os casos omissos resguardados à apreciação e
            deliberação exclusiva por parte da <strong>EmCasa.</strong>
          </p>
          <br />
          <p>
            <strong>1. DOS PARTICIPANTES</strong>
            <br />
            <strong>1.1</strong> Poderão participar do Programa todos os
            corretores de imóveis com inscrição ativa no Conselho Regional de
            Corretores de Imóveis (“CRECI”), que deverão cadastrar-se no site{' '}
            <Anchor
              to="/corretor-parceiro"
              onClick={() => onAnchorClick('link-corretor-parceiro')}
            >
              emcasa.com/corretor-parceiro
            </Anchor>
            .
            <br />
            <strong>1.2</strong> As informações cadastradas no site serão de
            única e exclusiva responsabilidade do corretor, eximindo a{' '}
            <strong>EmCasa</strong> de toda e qualquer informação cadastrada de
            forma incorreta.
          </p>
          <br />
          <p>
            <strong>2. DAS OBRIGAÇÕES</strong>
            <br />
            <strong>2.1</strong> A <strong>EmCasa</strong> providenciará a
            publicação do imóvel, após análise interna, de acordo com os
            parâmetros exclusivos da <strong>EmCasa</strong>. O imóvel será
            publicado somente após essa análise prévia. A{' '}
            <strong>EmCasa</strong> se resguarda no direito de não publicar o
            imóvel indicado, caso não seja de interesse da{' '}
            <strong>EmCasa</strong> ou não atenda suas diretrizes.
            <br />
            <strong>2.2</strong> A <strong>EmCasa</strong> disponibilizará
            relatórios para acompanhamento das indicações, exibindo seus
            respectivos status, na área logada individual de cada Corretor
            Captador, no site da <strong>EmCasa</strong>{' '}
            <Anchor to="/" onClick={() => onAnchorClick('link-home-emcasa')}>
              (emcasa.com)
            </Anchor>
            .
            <br />
            <strong>2.3</strong> A <strong>EmCasa</strong> providenciará o
            pagamento das comissões devidas conforme cláusulas dispostas neste
            Programa.
            <br />
            <strong>2.4</strong> O Corretor Captador deverá cadastrar sua
            indicação com os dados corretos, sob pena de desqualificação da
            indicação, excluindo sua indicação do Programa.
          </p>
          <br />
          <p>
            <strong>3. DAS COMISSÕES</strong>
            <br />
            <br />
            <strong>3.1</strong> O valor do pagamento da comissão a ser
            realizado pela <strong>EmCasa</strong> ao Corretor Captador
            corresponderá a 15% (quinze por cento) do valor da comissão recebida
            pela <strong>EmCasa</strong> para imóveis localizados no estado de
            São Paulo e 20% (vinte por cento) para imóveis localizados no estado
            do Rio de Janeiro.
            <br />
            <strong>3.2</strong> O pagamento a ser realizado pela{' '}
            <strong>EmCasa</strong> ao Corretor Captador deverá ocorrer no 8°
            (oitavo) dia útil do mês subsequente à finalização da venda pela{' '}
            <strong>EmCasa</strong>. O prazo para recebimento terá como
            referência o mês em que a venda se concretizou e que a{' '}
            <strong>EmCasa</strong> foi remunerada, podendo se estender por
            tempo indefinido, até que a venda seja efetivamente concluída
            (assinatura da escritura pública).
            <br />
            <strong>3.3</strong> O pagamento será realizado pela{' '}
            <strong>EmCasa</strong> mediante emissão e envio de Nota Fiscal pelo
            Corretor Captador, conforme item 4 deste regulamento. Na hipótese da
            não emissão da Nota Fiscal, o pagamento não será devido.
            <br />
            <strong>3.4</strong> O pagamento será feito descontado os valores
            dos impostos incidentes devidos, conforme legislação tributária
            aplicável. O Corretor Captador poderá solicitar o detalhamento dos
            descontos quando do recebimento da comissão.
          </p>
          <br />
          <p>
            <strong>4. DAS OBRIGAÇÕES FISCAIS</strong>
            <br />
            <strong>4.1</strong> Para recebimento de comissão referente à venda
            de imóvel, o corretor captador deve emitir uma Nota Fiscal
            específica, utilizando a descrição de serviço “Agenciamento,
            corretagem ou intermediação de bens imóveis”.
            <br />
            <strong>4.2</strong> Para recebimento de comissão referente à
            publicação de imóvel, o Corretor Captador deve emitir uma Nota
            Fiscal específica, utilizando a descrição de serviço “Agenciamento,
            corretagem ou intermediação de títulos em geral, valores mobiliários
            e contratos quaisquer”.
            <br />
            <strong>4.3</strong> A <strong>EmCasa</strong> irá solicitar o envio
            da Nota Fiscal por e-mail. A Nota Fiscal deve ser enviada à{' '}
            <strong>EmCasa</strong> no prazo de até 24 horas após o recebimento
            da solicitação.
            <br />
            <strong>4.4</strong> Não serão aceitas Notas Fiscais que somem
            valores referentes à publicação e venda em um único documento. Cada
            evento requer a emissão de uma Nota Fiscal separada, conforme as
            descrições de serviço mencionadas nos itens 4.1 e 4.2.
            <br />
            <strong>4.5</strong> Se o Corretor Captador não for optante pelo
            Simples Nacional, a <strong>EmCasa</strong> reterá 1,5% de Imposto
            de Renda Retido na Fonte (IRRF) sobre o valor da comissão da venda.
            Para corretores optantes pelo Simples Nacional, a{' '}
            <strong>EmCasa</strong> não fará retenção de impostos, cabendo ao
            corretor parceiro a responsabilidade por suas obrigações fiscais.
            <br />
            <strong>4.6</strong> Todos os pagamentos de comissões, tanto de
            publicação quanto de venda, serão realizados exclusivamente em
            contas bancárias vinculadas ao CNPJ do Corretor Captador.
          </p>
          <br />
          <p>
            <strong>5. PRAZO DE VIGÊNCIA</strong>
            <br />
            <strong>5.1</strong> O Programa possui prazo indeterminado de
            duração e desde já a <strong>EmCasa</strong> poderá revogá-lo a
            qualquer momento, devendo providenciar todos os pagamentos devidos
            (comissões recebidas).
          </p>
          <br />
          <p>
            <strong>6. PRIVACIDADE DE DADOS</strong>
            <br />
            <strong>6.1</strong> A <strong>EmCasa</strong> declara que realiza o
            tratamento adequado de dados, conforme Lei no 13.709/2018 (LGPD) e
            demais legislações aplicáveis e que todas os dados armazenados foram
            obtidos de forma lícita com finalidade previamente definida. Para
            mais informações, por favor acessar nosso termo de privacidade de
            dados, constante no site.
          </p>
          <p>
            <strong>7. CONDIÇÕES GERAIS</strong>
            <br />
            <strong>7.1</strong> O prazo máximo entre a indicação e publicação
            do imóvel será de até 06 (seis) meses, contados a partir da data em
            que a indicação foi recebida pela <strong>EmCasa</strong>. Passado
            esse período, mesmo que a publicação seja feita e evolua para uma
            venda, não será devido nenhum valor da <strong>EmCasa</strong> em
            favor do Corretor Captador.
            <br />
            <strong>7.2</strong> Na hipótese de constatada fraude ou violação às
            normas do Programa, o Corretor Captador será imediatamente
            desqualificado e se algum valor já tiver sido pago pela{' '}
            <strong>EmCasa</strong>, deverá ser devolvido sob pena de aplicação
            das medidas judiciais cabíveis.
            <br />
            <strong>7.3</strong> A <strong>EmCasa</strong> se reserva no direito
            de alterar o Programa e seu respectivo regulamento, devendo dar
            publicidade ao novo regulamento por meio de sua plataforma online,
            sem aviso prévio.
            <br />
            <strong>7.4</strong> O logotipo, marca e nome da{' '}
            <strong>EmCasa</strong> não poderão ser reproduzidos sem autorização
            expressa, sob pena das medidas judiciais cabíveis.
            <br />
            <strong>7.5</strong> A participação no Programa em seus devidos
            termos será considerada aceita a partir do cadastro do corretor
            parceiro no site da <strong>EmCasa</strong>, não podendo alegar
            desconhecimento do presente regulamento.
            <strong>7.6</strong> Fica eleito o foro da cidade de São Paulo para
            dirimir eventuais litígios, excluindo-se qualquer outro por mais
            privilegiado que seja.
          </p>
          <br />
          <br />

          <p>
            👉 Em caso de dúvidas, enviar um e-mail para:{' '}
            <Anchor
              target="_blank"
              href={String(
                `mailto:parcerias@emcasa.com?subject=${encodeURIComponent(
                  'Parcerias EmCasa - Cadastro Corretor Parceiro'
                )}`
              )}
              onClick={() => onAnchorClick('email')}
            >
              parcerias@emcasa.com
            </Anchor>
          </p>
          <br />
        </div>
      </div>
    </Modal>
  )
}

export default CPTermsModal
